import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Logo from './Logo'; // Ajuste o caminho se precisar!

const HeaderStyle = styled('div')(({ theme }) => ({
  width: '100vw', // pega a largura total da tela
  minHeight: 75, // altura padrão de topo (ajuste como preferir!)
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between', // separa logo à esquerda, versão à direita
  padding: theme.spacing(0, 4), // padding horizontal só pros itens respirarem
  position: 'fixed', // fixa no topo sempre
  top: 0,
  left: 0,
  zIndex: 1201, // acima dos cards/navegação
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[1],
  borderRadius: 0, // tira cantos arredondados, é barra 100%
}));

export default function LoginHeader() {
  return (
    <HeaderStyle>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Logo style={{ height: 32 }} />
          <Typography
            variant="h6"
            sx={{ color: 'text.primary', ml: 1, fontWeight: 700 }}
          >
            TECNOZAP SUPORTE
          </Typography>
        </Box>
        <Typography
          variant="caption"
          sx={{ color: 'GrayText', marginLeft: 'auto', fontWeight: 500 }}
        >
          {`v${process.env.REACT_APP_VERSION}`}
        </Typography>
      </Stack>
    </HeaderStyle>
  );
}
